import React, { useState, useEffect } from 'react';
import './Carousel.css';

const Carousel = ({ articles }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying || articles.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % articles.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [currentIndex, isAutoPlaying, articles.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? articles.length - 1 : prevIndex - 1
    );
    setIsAutoPlaying(false);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % articles.length);
    setIsAutoPlaying(false);
  };

  if (articles.length === 0) return null;

  const currentArticle = articles[currentIndex];

  return (
    <div className="carousel-container">
      <a
        href={currentArticle.link}
        target="_blank"
        rel="noopener noreferrer"
        className="carousel-slide"
        style={{ backgroundImage: `url(${currentArticle.imageUrl})` }}
      >
        <div className="carousel-overlay">
          <div className="carousel-content">
            <span className="carousel-source">{currentArticle.source}</span>
            <h2 className="carousel-title">{currentArticle.title}</h2>
            <p className="carousel-description">{currentArticle.description}</p>
          </div>
        </div>
      </a>

      <button className="carousel-arrow carousel-arrow-left" onClick={(e) => { e.preventDefault(); goToPrevious(); }}>
        ‹
      </button>
      <button className="carousel-arrow carousel-arrow-right" onClick={(e) => { e.preventDefault(); goToNext(); }}>
        ›
      </button>

      <div className="carousel-indicators">
        {articles.map((_, index) => (
          <button
            key={index}
            className={`carousel-indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
